import React, { useState } from 'react';
import { Modal } from 'antd';
import { get } from 'lodash';
import { withApollo } from 'react-apollo';
import { bool, func, object } from 'prop-types';
import { Text, FlexContainer, Row, Icon, Button, IconContainer } from '../../common';
import UpdateShopperNotification from '../../graphql/updateShopperNotification';

export const ModalDelete = ({ visible, toggleModal, notification, client }) => {
    const [loading, setLoading] = useState(false);

    return (
        <Modal
            closable={false}
            visible={visible}
            footer={null}
            destroyOnClose
        >
            <FlexContainer align='center' direction='column'>
                <IconContainer color='#f38630'>
                    <Icon name='trash' color='#ffffff' size={46.8} />
                </IconContainer>
                <FlexContainer mY={30} direction='column' align='center'>
                    <Row justify='center'>
                        <Text text={`Eliminarás notificación de ${get(notification, 'name')},\u00a0`} />
                    </Row>
                    <Row>
                        <Text centered text='¿Estás seguro?' />
                    </Row>
                </FlexContainer>
                <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                    <Button
                        link
                        text='btn.action.cancel'
                        style={{ width: '100px' }}
                        onClick={() => toggleModal()}
                    />
                    <Button
                        disabled={loading}
                        loading={loading}
                        text='btn.action.confirm'
                        style={{ width: '100px' }}
                        onClick={() => {
                            setLoading(true);
                            client.mutate({
                                mutation: UpdateShopperNotification,
                                variables: { input: {
                                    idNotification: get(notification, 'id_notification'),
                                    status: 4
                                } },
                                refetchQueries: ['getShopperNotifications']
                            }).then(() => {
                                setLoading(false);
                                toggleModal();
                            });
                        }}
                    />
                </FlexContainer>
            </FlexContainer>
        </Modal>
    );
};

ModalDelete.propTypes = {
    visible: bool,
    toggleModal: func,
    notification: object,
    client: object
};

export default withApollo(ModalDelete);
